// extracted by mini-css-extract-plugin
var _1 = "SelectRootItem_base__039b9";
var _2 = "SelectRootItem_disabled__54339";
var _3 = "SelectRootItem_error__4a76f";
var _4 = "SelectRootItem_label__49c04";
var _5 = "SelectRootItem_large__c565d";
var _6 = "SelectRootItem_medium__d3410";
var _7 = "SelectRootItem_mini__d8573";
var _8 = "SelectRootItem_single__f6982";
var _9 = "SelectRootItem_stroke__46ee3";
var _a = "SelectRootItem_tag__f1ed5";
var _b = "SelectRootItem_xmini__24012";
export { _1 as "base", _2 as "disabled", _3 as "error", _4 as "label", _5 as "large", _6 as "medium", _7 as "mini", _8 as "single", _9 as "stroke", _a as "tag", _b as "xmini" }
